import { Component, Input } from '@angular/core';
import { ElementData } from '@app/core/models/courses.model';

@Component({
  selector: 'app-image-card',
  templateUrl: './image-card.component.html',
  styles: [],
  standalone: false,
})
export class ImageCardComponent {
  @Input() public element: ElementData;
  @Input() public fullWidth = false;
  @Input() public fullSize = false;
}
